var React = require('react');
var createReactClass = require('create-react-class');
var PostModule = require('./postModule.jsx');
var BackButton = require('../../../components/backButton.jsx');

var PostContainer = createReactClass({

	render: function () {
        var postModuleNodes = this.props.postContainer.fields.postModules.map(function(postModule, index){
            return <PostModule postModule={postModule} key={index} />
        });

        return (
            <div className="postContainer">
                <div className="hd">
                    <h1>{this.props.postContainer.fields.title}</h1>
					<BackButton />
                </div>
                <div className="bd">
                    {postModuleNodes}
                </div>
            </div>
        );
    }
});

module.exports = PostContainer;



// WEBPACK FOOTER //
// ./src/common/routes/posts/components/layout/postContainer.jsx